export const PLAYER_BANNER_KEY = 'PLAYER_BANNER_KEY';
export const PLAYER_PROFILE_RESULTS_KEY = 'PLAYER_PROFILE_RESULTS_KEY';
export const PLAYER_DETAILS_MY_TEAMS_KEY = 'PLAYER_DETAILS_MY_TEAMS_KEY';
export const PLAYER_DETAILS_PLAYER_SPONSORS_KEY = 'PLAYER_DETAILS_PLAYER_SPONSORS_KEY';
export const PLAYER_PROFILE_STATS_KEY = 'PLAYER_PROFILE_STATS_KEY';
